import { formatTimeAgo } from "~shared/format"

export function TimeAgo({ timestamp }: { timestamp: number }) {
	return (
		<time className="text-app-text-secondary text-sm" dateTime={new Date(timestamp).toISOString()}>
			{formatTimeAgo(timestamp)}
		</time>
	)
}
